export const cardStyle = {
  boxShadow:
    "0 0.46875rem 2.1875rem rgba(8.3, 10.1, 36.6, 0.03), 0 0.9375rem 1.40625rem rgba(8.3, 10.1, 36.6, 0.03), 0 0.25rem 0.53125rem rgba(8.3, 10.1, 36.6, 0.05), 0 0.125rem 0.1875rem rgba(8.3, 10.1, 36.6, 0.03)",
  borderWidth: 0,
  transition: "all 0.2s",
  backgroundColor: "#FFF",
};

export const headerBoxStyle = {
  background: "#FFF",
  padding: "24px 40px",
  width: "100%",
  marginBottom: "16px",
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
};

export const titleTextStyle = {
  color: "rgba(17.8, 21.5, 78.1, 0.7)",
  fontSize: "1.1rem",
  fontWeight: 400,
  lineHeight: 1.5,
  fontFamily:
    '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, "Noto Sans", sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji"',
};

export const infoTextStyle = {
  fontWeight: 400,
  fontSize: "14px",
  lineHeight: "21px",
  color: "#495057",
};

export const hoursBoxStyle = {
  background: "#B3FFA6",
  color: "#0C5500",
  borderRadius: "35px",
  padding: "4px 12px",
  fontSize: "16px",
  lineHeight: "21px",
  fontWeight: 400,
  height: "30px",
  width: "auto",
  minWidth: "50px",
  marginLeft: 1,
  whiteSpace: "nowrap",
};
